import './tooltip.scss';

class Tooltip {
    constructor (element) {
        this.$tooltipTrigger = element;
    }

    initialize () {
        this.$tooltipTrigger.onclick = () => {
            const $tooltipContent = document.querySelector(`#${this.$tooltipTrigger.getAttribute('popovertarget')}`);
            const anchorRect = this.$tooltipTrigger.getBoundingClientRect();

            if ($tooltipContent) {
                const popoverRect = $tooltipContent.getBoundingClientRect();

                if (!window.mediaMatch[768].matches) {
                    $tooltipContent.style.top = `${anchorRect.bottom + popoverRect.height + window.scrollY}px`;
                    $tooltipContent.style.left = '0px';
                } else {
                    $tooltipContent.style.top = `${anchorRect.bottom + popoverRect.height + window.scrollY}px`;
                    $tooltipContent.style.left = `${anchorRect.left + window.scrollX}px`;
                }

                window.addEventListener('scroll', () => {
                    this.closePopover($tooltipContent);
                }, { once: true });

                window.addEventListener('resize', () => {
                    this.closePopover($tooltipContent);
                }, { once: true });
            }
        };
    }

    closePopover ($tooltipContent) {
        if ($tooltipContent.matches(':popover-open')) {
            $tooltipContent.hidePopover();
        }
    }
}

export { Tooltip };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$root = $context.querySelectorAll('[data-tooltip="root"]:not([data-init="true"])');

        $$root.forEach($root => {
            const tooltip = new Tooltip($root);
            tooltip.initialize();
            $root.setAttribute('data-init', 'true');
        });
    }
});
